<template>
  <span>
    <template v-if="value.includes && value.includes.length > 0">
      {{ $t('Post(s) will be replied') }} ({{ value.includes.length }})
    </template>
    <template v-else-if="value.excludes && value.excludes.length > 0">
      {{ $t("Post(s) won't be replied") }} ({{ value.excludes.length }})
    </template>
    <template v-else-if="value.post_keywords && value.post_keywords.length > 0">
      {{ $t('Post(s) that has keywords') }} ({{ value.post_keywords.length }})
    </template>
    <template v-else>
      {{ $t('Replying all post(s)') }}
    </template>
  </span>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentSelectPostLabel.vue